import { Label } from "@logora/parliament.ui.label";
import React from "react";
import styles from "./CalendarItem.module.scss";

export const CalendarItem = ({
	startTime,
	location,
	title,
	category,
	link,
}) => {
	// Determine the type of event to apply the correct styling
	const getEventType = () => {
		if (category === "seance_type") {
			return "Débat en séance";
		}
		if (category === "reunionCommission_type") {
			return "Commission";
		}
		if (category === "reunionInitParlementaire_type") {
			return "Réunion";
		}
		return category;
	};

	const capitalizeFirstLetter = (tag) => {
		return tag.charAt(0).toUpperCase() + tag.slice(1);
	};

	return (
		<div className={`${styles.calendarItem} ${styles[category]}`}>
			<div className={styles.header}>
				<div className={styles.timeHeader}>
					{new Date(startTime)
						.toLocaleTimeString("fr-FR", {
							hour: "2-digit",
							minute: "2-digit",
						})
						.replace(":", "h")}
				</div>
				<div className={styles.locationHeader}>{location}</div>
			</div>
			{category && <Label text={getEventType()} />}
			{title && (
				<div title={title} className={styles.title}>
					{capitalizeFirstLetter(title)}
				</div>
			)}
			<a
				href={link}
				target="_blank"
				className={styles.linkButton}
				rel="noreferrer"
			>
				Voir la réunion
				{/* biome-ignore lint/a11y/noSvgWithoutTitle: <explanation> */}
				<svg
					xmlns="http://www.w3.org/2000/svg"
					viewBox="0 0 24 24"
					fill="currentColor"
				>
					<path d="M16.172 11l-5.364-5.364 1.414-1.414L20 12l-7.778 7.778-1.414-1.414L16.172 13H4v-2z" />
				</svg>
			</a>
		</div>
	);
};
